import React from 'react'
import "./Nav.css"
import { useState } from 'react'


const Nav = () => {
  let resume = "https://docs.google.com/document/d/1oq3SJ3oxYZAC3VzfiemKOfpkUaN-KO99XvfqzVLLqvo/edit#heading=h.ymi089liagec"
  const [activeNav, setActiveNav] = useState("#home")

  return (
    <>
    <nav className='first-nav sticky top-0 z-50 bg-[#1a1a1a]'>
      <div  className="text-[grey] tablet-nav lg:block hidden ml-auto sm:px-6 lg:px-8 py-8 space-x-9">
      <a href="#home" onClick={() => setActiveNav('#home')}   className={activeNav === '#home' ? 'active' : ''}>Home</a>
      <a href="#work" onClick={() => setActiveNav('#work')}  className={activeNav === '#work' ? 'active' : ''}>Work</a>
      <a href="#contact"  onClick={() => setActiveNav('#contact')}  className={activeNav === '#contact' ? 'active' : ''}>Contact</a>
      <a href={resume} target="_blank">Resume</a>
      </div>
    </nav>
    <nav className='lg:hidden hidden nav'>
    <a href="#home" onClick={() => setActiveNav('#home')}   className={activeNav === '#home' ? 'active' : ''}>Home</a>
    <a href="#work" onClick={() => setActiveNav('#work')}  className={activeNav === '#work' ? 'active' : ''}>Work</a>
    <a href="#contact" onClick={() => setActiveNav('#contact')}  className={activeNav === '#contact' ? 'active' : ''}>Contact</a>
    <a href="https://docs.google.com/document/d/1oq3SJ3oxYZAC3VzfiemKOfpkUaN-KO99XvfqzVLLqvo/edit#heading=h.ymi089liagec" target='_blank' onClick={() => setActiveNav('https://docs.google.com/document/d/1oq3SJ3oxYZAC3VzfiemKOfpkUaN-KO99XvfqzVLLqvo/edit#heading=h.ymi089liagec')}  className={activeNav === 'https://docs.google.com/document/d/1oq3SJ3oxYZAC3VzfiemKOfpkUaN-KO99XvfqzVLLqvo/edit#heading=h.ymi089liagec' ? 'active' : ''}>Resume</a>
  </nav>
    <nav className='xsm:hidden nav-sm'>
    <a href="#home" onClick={() => setActiveNav('#home')}   className={activeNav === '#home' ? 'active' : ''}>Home</a>
    <a href="#works" onClick={() => setActiveNav('#works')}  className={activeNav === '#works' ? 'active' : ''}>Work</a>
    <a href="#contact" onClick={() => setActiveNav('#contact')}  className={activeNav === '#contact' ? 'active' : ''}>Contact</a>
    <a href="https://docs.google.com/document/d/1oq3SJ3oxYZAC3VzfiemKOfpkUaN-KO99XvfqzVLLqvo/edit#heading=h.ymi089liagec" target='_blank' onClick={() => setActiveNav('https://docs.google.com/document/d/1oq3SJ3oxYZAC3VzfiemKOfpkUaN-KO99XvfqzVLLqvo/edit#heading=h.ymi089liagec')}  className={activeNav === 'https://docs.google.com/document/d/1oq3SJ3oxYZAC3VzfiemKOfpkUaN-KO99XvfqzVLLqvo/edit#heading=h.ymi089liagec' ? 'active' : ''}> Resume</a>
  </nav>
  </>
  )
}

export default Nav
